import { render, staticRenderFns } from "./UpdateProductPrice.vue?vue&type=template&id=5fd402ac&scoped=true&"
import script from "./UpdateProductPrice.vue?vue&type=script&lang=js&"
export * from "./UpdateProductPrice.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProductPrice.vue?vue&type=style&index=0&id=5fd402ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd402ac",
  null
  
)

export default component.exports